<form #activeForm="ngForm">
    <app-custom-modal #modal [title]="'Ativar convênio'" [subtitle]="'Tem certeza que deseja ativar este convênio?'"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" [saveLabel]="'Sim, ativar'" hideCancel
        [saveDisabled]="activeForm.invalid" [buttonImage]="'hgi hgi-stroke hgi-checkmark-circle-03 icon-color-green'">
        <div class="table-container table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Razão Social</th>
                        <th>CNPJ</th>
                        <th>Modalidade</th>
                        <th>E-mail</th>
                        <th>Representante</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{convenio.razaoSocial}}</td>
                        <td>{{convenio.cnpj | mask: "00.000.000/0000-00"}}</td>
                        <td>{{convenio.autoGestao ?  "Autogestão" : "Gestão tradicional"}}</td>
                        <td>{{convenio.email}}</td>
                        <td>{{convenio.representante}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </app-custom-modal>
</form>